define('adminKitlTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('kitls.details.tabTitle'),
      isDefault: true
    }
  ];
});
